import React, { FC } from 'react';
import styled from 'styled-components';
import {
  Black,
  DeliveredStatus,
  InProgressStatus,
  OnRoadStatus,
  PotentialStatus,
  ProcessedStatus,
  RejectedStatus,
} from '../../styles/colours';

const statusColor = (status: string): string => {
  switch (status) {
    // Retail statuses
    case 'POTENTIAL':
      return PotentialStatus;
    case 'PLANNED':
      return ProcessedStatus;
    case 'LOADED':
      return InProgressStatus;
    case 'ON ROAD':
      return OnRoadStatus;
    case 'ON ROAD < 30km':
      return OnRoadStatus;
    case 'ON ROAD < 5km':
      return OnRoadStatus;
    case 'DELIVERED':
      return DeliveredStatus;
    case 'CANCELLED':
      return RejectedStatus;

    // Other businesses
    case 'Scheduled':
      return InProgressStatus;
    case 'Loaded':
      return InProgressStatus;
    case '1 day away':
      return InProgressStatus;
    case '2 hours away':
      return InProgressStatus;
    case '5 Kms away':
      return InProgressStatus;
    case '30 Kms away':
      return InProgressStatus;
    case 'Delay':
      return InProgressStatus;
    case 'Delivered':
      return DeliveredStatus;
    default:
      return Black;
  }
};

const StyledTmsStatus = styled.span<{ status: string }>`
  font-weight: bold;
  border-radius: 4px;
  color: ${({ status }) => statusColor(status)};
`;

export const TMSStatusBadge: FC<{ status: string }> = ({ status }) => {
  return <StyledTmsStatus status={status}>{status}</StyledTmsStatus>;
};
